import { LoginContextType } from '@/hooks/useLogin';
import { LoginSignupFlowInitiatedFrom } from '@/types/analytics';
import { modalConstants } from '../constants';

export const modalActions = {
  redirect,
  hideModal,
  login,
  userProfileOnboarding,
  userLocationOnboarding,
  nps,
  lastMinute,
};

function hideModal() {
  window.location.hash = '';
  return { type: modalConstants.HIDE, data: {} };
}

function login(
  props:
    | {
        show: true;
        loginContext: LoginContextType;
        initiatedFrom: LoginSignupFlowInitiatedFrom;
      }
    | {
        show: false;
      },
) {
  if (props.show) {
    props.loginContext.onOpen(props.initiatedFrom);
  }

  return { type: modalConstants.LOGIN, data: { show: props.show } };
}

function userProfileOnboarding({ show }: { show: boolean }) {
  return { type: modalConstants.USER_PROFILE_ONBOARDING, data: { show } };
}

function userLocationOnboarding({ show }: { show: boolean }) {
  return { type: modalConstants.USER_LOCATION_ONBOARDING, data: { show } };
}

function nps({ show }: { show: boolean }) {
  return { type: modalConstants.NPS, data: { show } };
}

function lastMinute({ show }: { show: boolean }) {
  return { type: modalConstants.LAST_MINUTE, data: { show } };
}

function redirect(type, url) {
  function red(url) {
    return { type: modalConstants.REDIRECT, data: url };
  }

  return (dispatch) => {
    dispatch(red(url));
    setTimeout(() => {
      dispatch(hideModal());
    }, 100);
  };
}
